export const numTables = `title: Global CO2 Emissions by Sector, Gt CO2/year

---
columnTitle: Sector
columnTitle: 2000
columnTitle: 2010
columnTitle: 2022
columnTitle: Change since 2000
---
Electricity and heat
8.4
11.2
13.5
+61%
---
Transport
5.2
6.9
7.7
+48%
---
Manufacturing and construction
4.3
5.8
6.4
+49%
---
Buildings (direct)
2.7
3.0
2.9
+7%
---
Fugitive emissions
1.7
1.9
2.1
+24%
---
Agriculture
1.4
1.5
1.6
+14%
---
Waste
0.5
0.5
0.6
+20%
---
Other
1.2
1.4
1.5
+25%
-->

Source: IEA World Energy Outlook 2023, Table A.1. Figures rounded to nearest 0.1 Gt. Sector definitions follow IPCC AR6 categories.
`;